import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { userInfo as fetchUserInfo } from 'reporting-data/request/user-info';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
// @ts-expect-error Untyped dependency
import ReportErrored from './../../reports/inferLogic/components/states/ReportErrored';
// @ts-expect-error Untyped dependency
import ReportLoading from './../../reports/inferLogic/components/states/ReportLoading';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserInfoProvider = ({
  userInfo: passedInUserInfo,
  children
}) => {
  const hasPassedInUserInfo = passedInUserInfo && passedInUserInfo.gates && passedInUserInfo.gates.length > 0;
  const [userInfo, setUserInfo] = useState(hasPassedInUserInfo ? passedInUserInfo : undefined);
  const [userInfoError, setUserInfoError] = useState(undefined);
  useEffect(() => {
    if (!hasPassedInUserInfo) {
      fetchUserInfo().then(settings => {
        setUserInfo(settings);
      }).catch(err => {
        setUserInfoError(err);
      });
    }
  }, [hasPassedInUserInfo]);
  if (userInfoError !== undefined) {
    return /*#__PURE__*/_jsx(ReportErrored, {
      error: userInfoError
    });
  }
  if (userInfo === undefined) {
    return /*#__PURE__*/_jsx(ReportLoading, {});
  }
  return /*#__PURE__*/_jsx(UserInfoContext.Provider, {
    value: userInfo,
    children: children
  });
};
UserInfoProvider.displayName = 'UserInfoProvider';
UserInfoProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default UserInfoProvider;

/**
 * Helper to wrap a downstream component in UserInfoProvider.
 * Some components (e.g. DrilldownViewer, ReportResolver) are part of multiple public
 * interfaces where a parent may or may not provide userInfoContext.  This component
 * either transfer UserInfoContext from upstream component or create one for downstream components.
 */

export const WithUserInfoProvider = Component => {
  return function WithUserInfoContext(props) {
    const userInfoFromContext = useContext(UserInfoContext);
    const userInfoFromProps = props && props.userInfo;
    return /*#__PURE__*/_jsx(UserInfoProvider, {
      userInfo: userInfoFromProps || userInfoFromContext,
      children: /*#__PURE__*/_jsx(Component, Object.assign({}, props))
    });
  };
};